import React from 'react'
import axios from 'axios'

export default class Indicadores extends React.Component {
	constructor(props) {
		super(props)
		this.state = { loaded: false }
	}

	componentDidMount() {
		const url = '/api/auth/checkAuth'
		axios(url)
			.then(resp => {
				this.setState({ loaded: true })
			})
			.catch(error => {
				alert(error.response.data)
			}
			)
	}

	render() {
		if (this.state.loaded) {
			if (localStorage.tipo == "coordenacao" || localStorage.tipo == "presidencia" ||
				localStorage.tipo == "vice-presidencia" || localStorage.tipo == "interno" || 
				localStorage.tipo == "defis" || localStorage.tipo == "fiscalAssessor" ||
				localStorage.nome == "Tatiane Lima" || localStorage.nome == "Sthefany Grilo") {
					return (
						<React.Fragment>
							<div className="container">
							<iframe width="1024" height="804" src="https://app.powerbi.com/view?r=eyJrIjoiNDEzMDkwNGEtNDY5NC00NzZkLTk3MmEtY2E0ZDhiZTliZDEzIiwidCI6IjNjNjE5YTUwLWM2OGMtNGQ1OC1iMmQ3LWY0NDAyNTYwYWYyYyJ9" frameborder="0" allowFullScreen="true"></iframe>
							</div>
						</React.Fragment>
					)
				} else {
					return window.location = '/'
				}
		} else {
			return <div></div>
		}
	}
}